/**
 * betta
 * Require all individual files is whatever order is necessary
 *
 * @package:  betta
 * @version:  2.3
 * @author:   Cyrill N KALITA
 */

require('./checkbox-at-least-one.js');
require('./checkbox-singular.js');
require('./datatables.js');
require('./datepicker.js');
require('./default-timezone.js');
require('./disable-on-click.js');
require('./disable-on-submit.js');
require('./file-upload-field.js');
require('./form-reset.js');
require('./google-address-autocomplete.js');
require('./ie10-viewport-bug-workaround.js');
require('./input-trim.js');
require('./jquery.chained.js');
require('./load-progress-bar.js');
require('./modal-remote-refresh.js');
require('./modal-remote-resize.js');
require('./modal-remote-scroll.js');
require('./modal-remote-secondary.js');
require('./modal-remove.js');
require('./modal-upload.js');
require('./prevent-default.js');
require('./pubsub.js');
require('./pubsub.subscribe-form.js');
require('./pubsub.subscribe-remote.js');
require('./pubsub.subscribe-resource.js');
require('./require-if-visible.js');
require('./sanitize-currency.js');
require('./select-all.js');
require('./select-other-array.js');
require('./select-other.js');
require('./select2.conferences.js');
require('./submit-on-change.js');
require('./timepicker.js');
require('./tinymce.js');
require('./treegrid.js');
